import React, { useEffect, useState } from 'react'
import { Box, Typography } from '@mui/joy'
import { useSettingsContext, useSettingContextInComponent } from 'src/mtska-frontend-app-scaffolding'
import JSONPretty from 'react-json-pretty';
import { Icon } from 'src/mtska-frontend-app-component/assets';
import { useTranslation, Trans } from 'react-i18next';
import { getOperatorsByType } from './list.functions';

const defaultOperators = [
    { "label": "Contiene", "value": "contains" },
    { "label": "Non contiene", "value": "doesNotContain" },
    { "label": "Uguale a", "value": "equals" },
    { "label": "Non uguale a", "value": "doesNotEqual" },
    { "label": "Inizia con", "value": "startsWith" },
    { "label": "Finisce con", "value": "endsWith" },
    { "label": "È vuoto", "value": "isEmpty" },
    { "label": "Non è vuoto", "value": "isNotEmpty" }
];

const FiltersPanel = (props) => {
    const { drawable, filterModel } = useSettingContextInComponent(props.dataProviderName);
    const { addFilter, removeFilter, emptyFilters, replaceFilters } = useSettingsContext(props.dataProviderName);

    const { t } = useTranslation();

    return (
        drawable &&
        <Box className="mtska-filter-panel" sx={{
            display: 'grid',
            gridTemplateRows: '40px 40px auto 90px',
            height: '100vh',
            margin: '0 10px'
        }}>

            <h4 style={{ margin: 0, lineHeight: '40px', borderBottom: '2px solid #666' }}>
                <Trans
                    i18nKey="filterManagement"
                    components={{ light: <span style={{ fontWeight: '200' }} /> }}
                />
            </h4>
            <FilterHeader />

            <div className='filterRowsScroller' style={{ overflowY: 'scroll' }}>
                <div className='filterRows'>
                    {filterModel && filterModel.items
                        .filter(filter => filter.value !== undefined)
                        .map(filter => (
                            <FilterRow filter={filter} columns={props.columns} filterModel={filterModel} removeFilter={removeFilter} replaceFilters={replaceFilters} />
                        ))
                    }
                    {
                        <a onClick={() => emptyFilters()} style={{ color: 'var(--customer-500)', fontSize: '12px', lineHeight: '40px', marginLeft: '5px', cursor: 'pointer', transition: 'color 0.2s ease', ':hover': { color: 'var(--customer-700)' } }} ><Icon icon="faSquareXmark" family='fas' style={{ marginRight: '5px' }} />{t('erase_all_filters')}</a>
                    }
                </div>
            </div>

            <FilterRowAdd addFilter={addFilter} columns={props.columns} />
        </Box>
    )
}

const FilterHeader = () => {
    const { t } = useTranslation();

    return (<div className="filter-header" style={{
        display: 'grid',
        gridTemplateColumns: '140px 140px 200px 30px',
        gap: '10px',
        padding: '10px',
        fontWeight: '300',
        fontSize: '13px',
        lineHeight: '30px',
        color: '#333',
        borderBottom: '1px solid #666',
    }}>
        <div>{t('field')}</div>
        <div>{t('operator')}</div>
        <div>{t('value')}</div>
        <div></div>
    </div>)
}

const FilterRow = ({ filter, columns, filterModel, removeFilter, replaceFilters }) => {
    const { t } = useTranslation();

    //const [currentFilterItem, setCurrentFilterItem] = useState(filterModel?.items?.find(item => item.field === filter.field) ?? {});
    const [columnItem, setColumnItem] = useState(columns?.find(column => column.field === filter.field) ?? {});
    const [inputValue, setInputValue] = useState(filter.value);
    const [inputOperator, setInputOperator] = useState(filter.operator);

    const [availableOperators, setAvailableOperators] = useState(
        getOperatorsByType(t, columnItem?.type)
    );
    const [availableOptions, setAvailableOptions] = useState(
        columnItem.options?.length > 0
            ? columnItem.options
            : null
    );
    const [availableFilterType, setAvailableFilterType] = useState(
        columnItem.filterType
    );

    useEffect(() => {
        setInputValue(filter.value);
    }, [filter.value]);

    useEffect(() => {
        setInputOperator(filter.operator);
    }, [filter.operator]);

    const debounceReplaceFilters = (newFilterModel) => {
        if (window.replaceFiltersTimeout) {
            clearTimeout(window.replaceFiltersTimeout);
        }

        window.replaceFiltersTimeout = setTimeout(() => {
            replaceFilters(newFilterModel);
        }, 300);
    }

    const handleOperatorChange = (operator) => {
        setInputOperator(operator);

        const newFilterItem = { ...filter };
        newFilterItem.operator = operator;

        if (['isEmpty', 'isNotEmpty'].includes(operator)) {
            newFilterItem.value = 'true';
        }

        const newFilterModel = { ...filterModel };
        newFilterModel.items = newFilterModel.items.map(item =>
            item.field === newFilterItem.field
                ? newFilterItem
                : item
        );

        debounceReplaceFilters(newFilterModel);
    }

    const handleValueChange = (value) => {
        setInputValue(value);

        const newFilterItem = { ...filter };
        newFilterItem.value = value;

        const newFilterModel = { ...filterModel };
        newFilterModel.items = newFilterModel.items.map(item => {
            return item.field === newFilterItem.field
                ? newFilterItem
                : item
        });

        debounceReplaceFilters(newFilterModel);
    }

    const fieldStyle = {
        width: '100%',
        padding: '5px',
        background: 'white',
        border: '1px solid var(--app-surface-dimmed)',
        borderRadius: '5px',
        lineHeight: '36px',
        height: '36px'
    }

    return (
        availableOperators &&
        <div className="filter-row" style={{ display: 'grid', gridTemplateColumns: '140px 140px 200px 30px', gap: '10px', alignItems: 'center', padding: '10px', borderBottom: '1px solid #ccc' }}>
            {/* Colonna Field */}
            <div className="filter-field">
                <strong style={{ fontSize: '14px' }}>{t(filter.field.replace('_related_', ''))}</strong>
                {/* <div style={{ fontSize: '0.8em', color: '#666' }}>
                    {filter.field} | {availableFilterType}
                </div> */}
            </div>

            {/* Colonna Operator */}
            <div className="filter-operator">
                <select
                    value={inputOperator}
                    style={fieldStyle}
                    onChange={(e) => handleOperatorChange(e.target.value)}
                >
                    {availableOperators.map(operator => (
                        <option key={operator.value} value={operator.value}>
                            {t(operator.value)}
                        </option>
                    ))}
                </select>
            </div>

            {/* Colonna Value */}
            <div className="filter-value">
                {availableFilterType === 'singleSelect' ? (
                    <select
                        value={inputValue}
                        style={fieldStyle}
                        onChange={(e) => handleValueChange(e.target.value)}
                    >
                        {availableOptions?.map(option => (
                            <option key={option} value={option}>
                                {t(option)}
                            </option>
                        ))}
                    </select>
                ) : availableFilterType === 'date' ? (
                    <input
                        type="date"
                        value={inputValue}
                        style={fieldStyle}
                        onChange={(e) => handleValueChange(e.target.value)}
                    />
                ) : (
                    <input
                        type="text"
                        value={inputValue}
                        style={fieldStyle}
                        onChange={(e) => handleValueChange(e.target.value)}
                    />
                )}
            </div>
            <Icon icon="faCircleXmark" onClick={() => removeFilter(filter.field)} family='fas' style={{ color: 'var(--customer-500)', cursor: 'pointer', transition: 'color 0.2s ease', ':hover': { color: 'var(--customer-700)' } }} />
        </div>
    );
};

const FilterRowAdd = ({ columns, addFilter }) => {
    const { t } = useTranslation();
    const [selectedField, setSelectedField] = useState();
    const [availableOperators, setAvailableOperators] = useState(defaultOperators);
    const [availableOptions, setAvailableOptions] = useState();
    const [selectedFieldValue, setSelectedFieldValue] = useState('');
    const [selectedOperator, setSelectedOperator] = useState('contains');
    const [value, setValue] = useState('');

    const handleAdd = () => {
        if (selectedFieldValue) {
            addFilter(selectedFieldValue, value, selectedOperator);
            setSelectedFieldValue('');
            setValue('');
            setSelectedOperator('contains');
        }
    };

    useEffect(() => {
        if (selectedFieldValue) {
            const selectedField = columns.find(column => column.field === selectedFieldValue);
            setSelectedField(selectedField);
            setValue('');
            setSelectedOperator('contains');
        }
    }, [selectedFieldValue, columns]);

    useEffect(() => {
        if (selectedField) {
            console.info('prova a sbirciare qui', selectedField)

            const availableOperators = getOperatorsByType(t, selectedField?.type);
            // const availableOperators = selectedField?.customFilters?.filterOperators?.length > 0
            //     ? selectedField.customFilters.filterOperators
            //     : defaultOperators;

            setAvailableOperators(availableOperators);

            const availableOptions = selectedField?.options?.length > 0
                ? selectedField.options
                : null;


            setAvailableOptions(availableOptions);
        }
    }, [selectedField]);

    const fieldStyle = {
        width: '100%',
        padding: '5px',
        background: 'white',
        border: '1px solid var(--app-surface-dimmed)',
        borderRadius: '5px',
        lineHeight: '40px',
        height: '40px'
    }

    return (
        <div className="filter-row-add" style={{ borderTop: '1px solid #CCC' }}>
            <Typography style={{ color: '#CCC', fontSize: '12px', lineHeight: '30px', marginLeft: '10px' }} >{t('add_new_filter')}</Typography>
            <div className="filter-row-add" style={{ display: 'grid', gridTemplateColumns: '140px 140px 200px 30px', gap: '10px', alignItems: 'center', padding: '0 10px' }}>
                <select
                    value={selectedFieldValue}
                    onChange={(e) => setSelectedFieldValue(e.target.value)}
                    style={fieldStyle}
                >
                    <option value="">{t("Select a field")}</option>
                    {
                        columns.map((column) => (
                            <option key={column.field} value={column.field}>
                                {t(column.field.replace('_related_', '').replace('_readable', '').replace('_numeric', ''))}
                            </option>
                        ))
                    }
                </select>

                <select
                    value={selectedOperator}
                    onChange={(e) => setSelectedOperator(e.target.value)}
                    style={fieldStyle}
                    readonly={availableOperators.length <= 1}
                >
                    <option value="">{t("Select an operator")}</option>
                    {availableOperators.map(operator => (
                        <option key={operator.value} value={operator.value}>
                            {t(operator.value)}
                        </option>
                    ))}
                </select>

                {
                    availableOptions ?
                        <select
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                            style={fieldStyle}
                        >
                            <option value="">{t("Select a value")}</option>
                            {availableOptions.map(option => (
                                <option key={option} value={option}>
                                    {t(option)}
                                </option>
                            ))}
                        </select>
                        :
                        <input
                            type="text"
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                            placeholder={t("Value")}
                            style={fieldStyle}
                        />
                }

                <Icon icon="faCirclePlus" onClick={() => handleAdd()} family='fas' style={{ color: 'var(--customer-500)', cursor: 'pointer', transition: 'color 0.2s ease', ':hover': { color: 'var(--customer-700)' } }} />

            </div>
        </div>
    );
};

export default FiltersPanel;